import React from 'react';
import { ToastContainer } from 'react-toastify';
import { SToastWrapper } from './styles';

const Toast = () => (
    <SToastWrapper>
        <ToastContainer hideProgressBar theme="colored" />
    </SToastWrapper>
);

export default Toast;
